import {
  airCancelApi,
  type AirCancelQuoteRequest,
  type AirCancelQuoteResponse,
} from "@b2bportal/air-cancel-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchCancelQuote = createAsyncThunk<
  AirCancelQuoteResponse,
  AirCancelQuoteRequest,
  { rejectValue: string }
>("cfar/air/cancelQuote", async (request: AirCancelQuoteRequest, thunkAPI) => {
  try {
    const res =
      await airCancelApi(axios).apiV0SelfserveFlightCancelQuotePost(request);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch air cancel quote", error);
    return thunkAPI.rejectWithValue(
      axios.isAxiosError(error) ? error.message : String(error)
    );
  }
});
